export default (theme: Object) => ({
  root: {
    alignItems: 'center',
    backgroundColor: theme.palette.neutrals.background,
    display: 'flex',
    flexFlow: 'row',
    justifyContent: 'space-between',
    height: '64px',
    padding: '0 5%',
    position: 'sticky',
  },
  logoLink: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    outline: 'none',
    position: 'relative',
    zIndex: theme.zIndex.tooltip + 1,
  },
  logo: {
    height: '31px',
    width: '111px',
  },
  title: {
    color: theme.palette.neutrals.mainText,
    fontSize: 19,
    textAlign: 'center',
    margin: 'auto',
    left:0,
    right:0,
    position: 'absolute'
  },
  button: {
    color: 'white',
  },
  startSigningIcon: {
    paddingRight: '5px',
  },
  buttons: {
    alignItems: 'right',
    display: 'flex',
    justifyContent: 'space-between',
  },
});
